<template>
  <div>
    <vs-popup :title="$t(popupTitle)" :active.sync="showModal">
      <form v-if="model != null">
        <vs-input
          class="inputx mb-4 mt-1"
          v-model="model.name"
          name="warehouseName"
          :label="$t('WarehouseName')"
          v-validate="'required'"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('warehouseName')"
          >{{ errors.first("warehouseName") }}</span
        >
        <vs-input
          class="inputx mb-4 mt-1"
          v-model="model.code"
          name="warehouseCode"
          :label="$t('WarehouseCode')"
        />

        <vs-input
          class="inputx mb-4 mt-1"
          v-model="model.automationCode"
          name="automationCode"
          :label="$t('AutomationCode')"
        />

        <label class="vs-select--label">{{ $t("Country") }}</label>
        <div v-if="isModify">
          <v-select
            label="name"
            name="country"
            :options="allCountries"
            :reduce="(x) => x.id"
            v-validate="{ required: true }"
            ref="countryListSelect"
            class="mb-4"
            v-model="model.location.countryId"
            @input="selectCountry"
            dir="rtl"
          >
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('country')">{{
            errors.first("country")
          }}</span>
        </div>
        <div v-if="!isModify">
          <v-select
            label="name"
            name="country"
            :options="allCountries"
            :reduce="(x) => x.id"
            v-validate="{ required: true }"
            ref="countryListSelect"
            class="mb-4"
            v-model="model.location.countryId"
            @input="selectCountry"
            dir="rtl"
          >
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('country')">{{
            errors.first("country")
          }}</span>
        </div>

        <label class="vs-select--label">{{ $t("Province") }}</label>
        <div v-if="isModify">
          <v-select
            label="name"
            name="province"
            :options="allProvinces"
            :reduce="(x) => x.id"
            v-model="model.location.provinceId"
            v-validate="{ required: true }"
            ref="provinceListSelect"
            class="mb-4"
            dir="rtl"
            @input="selectProvince"
          >
          </v-select>

          <span class="text-danger text-sm" v-show="errors.has('province')">{{
            errors.first("province")
          }}</span>
        </div>
        <div v-if="!isModify">
          <v-select
            label="name"
            :options="allProvinces"
            name="province"
            :reduce="(x) => x.id"
            v-validate="{ required: true }"
            ref="provinceListSelect"
            v-model="model.location.provinceId"
            @input="selectProvince"
            dir="rtl"
            class="mb-4"
          >
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('province')">{{
            errors.first("province")
          }}</span>
        </div>
        <label class="vs-select--label mt-4">{{ $t("City") }}</label>
        <div v-if="isModify">
          <v-select
            label="name"
            name="city"
            :options="allCities"
            :reduce="(x) => x.id"
            v-model="model.location.cityId"
            v-validate="{ required: true }"
            ref="cityListSelect"
            dir="rtl"
          >
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('city')">{{
            errors.first("city")
          }}</span>
        </div>
        <div v-if="!isModify">
          <v-select
            label="name"
            name="city"
            :options="allCities"
            :reduce="(x) => x.id"
            v-model="model.location.cityId"
            v-validate="{ required: true }"
            ref="cityListSelect"
            dir="rtl"
          >
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('city')">{{
            errors.first("city")
          }}</span>
        </div>

        <vs-input
          class="inputx mb-4 mt-4"
          v-model="model.location.address"
          name="address"
          :label="$t('WarehouseAddress')"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('address')">{{
          errors.first("address")
        }}</span>

        <vs-input
          class="inputx mb-4 mt-1"
          v-model="model.location.longitude"
          name="long"
          :label="$t('longitude')"
        />
        <vs-input
          class="inputx mb-4 mt-1"
          v-model="model.location.latitude"
          name="lat"
          :label="$t('latitude')"
        />
        <vs-button
          type="filled"
          class="float-right mb-4 mt-4"
          @click.prevent="submitForm"
          :disabled="disabled"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "vue-select";

const dict = {
  custom: {
    warehouseName: {
      required: "لطفا نام انبار را وارد نمایید.",
    },
    warehouseCode: {
      required: "لطفا کد انبار را وارد نمایید.",
    },
    country: {
      required: "لطفا کشور انبار را انتخاب نمایید.",
    },
    province: {
      required: "لطفا استان انبار را انتخاب نمایید.",
    },
    city: {
      required: "لطفا شهر انبار را انتخاب نمایید.",
    },
    address: {
      required: "لطفا آدرس انبار را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "warehouseManagement_Warehouses_ModifyPopup",
  components: {
    "v-select": vSelect,
  },
  props: {
    show: { default: false },
  },
  data() {
    return {
      popupTitle: "",
      model: null,
      isModify: false,
      disabled: false,
      province: "",
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
    ...mapGetters({
      allCountries: "country/countryList",
      allProvinces: "country/provinceList",
      allCities: "country/cityList",
      // locationInfo: "country/details",
    }),
  },
  mounted() {
    this.fetchProvinces();
    this.fetchCountry();
  },
  methods: {
    ...mapActions({
      createWarehouse: "warehouse/create",
      updateWarehouse: "warehouse/update",
      fetchProvinces: "country/fetchProvinces",
      fetchCountry: "country/fetchCountry",
      fetchCitiesById: "country/fetchCitiesById",
      fetchById: "country/fetchById",
      fetchProvincesById: "country/fetchProvincesByIdSupplier",
    }),
    submitForm() {
      this.model.location.countryName = this.allCountries.find(
        (x) => x.id === this.model.location.countryId
      ).name;
      this.model.location.provinceName = this.allProvinces.find(
        (x) => x.id === this.model.location.provinceId
      ).name;
      this.model.location.cityName = this.allCities.find(
        (x) => x.id === this.model.location.cityId
      ).name;

      const createPayload = {
        name: this.model.name,
        code: this.model.code,
        automationCode: this.model.automationCode,
        location: {
          countryId: this.model.location.countryId,
          countryName: this.model.location.countryName,
          provinceId: this.model.location.provinceId,
          provinceName: this.model.location.provinceName,
          cityId: this.model.location.cityId,
          cityName: this.model.location.cityName,
          address: this.model.location.address,
          longitude: this.model.location.longitude,
          latitude: this.model.location.latitude,
        },
      };
      const editPayload = {
        warehouseId: this.model.warehouseId,
        name: this.model.name,
        code: this.model.code,
        automationCode: this.model.automationCode,
        location: {
          countryId: this.model.location.countryId,
          countryName: this.model.location.countryName,
          provinceId: this.model.location.provinceId,
          provinceName: this.model.location.provinceName,
          cityId: this.model.location.cityId,
          cityName: this.model.location.cityName,
          address: this.model.location.address,
          longitude: this.model.location.longitude,
          latitude: this.model.location.latitude,
        },
      };
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.disabled = true;
          if (this.model.warehouseId != null) {
            this.updateWarehouse(editPayload).then(() => {
              this.clearFormAndBackToParentPage();
            });
          } else {
            this.createWarehouse(createPayload).then(() => {
              this.clearFormAndBackToParentPage();
            });
          }
        }
      });
    },
    clearFormAndBackToParentPage() {
      this.$emit("finish");
      this.$refs.provinceListSelect.clearSelection();
      this.$refs.cityListSelect.clearSelection();
      this.$validator.reset();
      this.disabled = false;
    },
    load(model) {
      if (model.warehouseId != null) {
        // this.locationInfo=model
        this.isModify = true;
        this.fetchProvincesById(model.location.countryId).then(() => {
          this.fetchCitiesById(model.location.provinceId);
        });
      } else {
        this.isModify = false;
      }
      var self = this;
      this.model = null;
      setTimeout(function () {
        self.model = model;
      }, 0);
    },
    selectProvince(province) {
      if (province !== null) {
        this.fetchCitiesById(province).then(() => {
          this.model.location.cityId = null;
          delete this.model.location.cityId;
        });
      }
    },
    selectCountry(country) {
      this.fetchProvincesById(country).then(() => {
        this.model.location.provinceId = null;
        this.model.location.cityId = null;
        delete this.model.location.provinceId;
        delete this.model.location.cityId;
      });
    },
  },

  watch: {
    show() {
      if (this.show == true) {
        if (this.isModify) {
          this.popupTitle = "EditWarehouse";
        } else {
          this.popupTitle = "CreateNewWarehouse";
        }
      }
    },
  },
};
</script>
